import { render, staticRenderFns } from "./RecetteApercu.vue?vue&type=template&id=54c6ce0c&scoped=true&"
import script from "./RecetteApercu.vue?vue&type=script&lang=js&"
export * from "./RecetteApercu.vue?vue&type=script&lang=js&"
import style0 from "./RecetteApercu.vue?vue&type=style&index=0&id=54c6ce0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c6ce0c",
  null
  
)

export default component.exports